import React from "react";
import { Field } from "formik";
import FormContainer from "forms/components/FormContainer";
import FormRow from "forms/components/FormRow";
import { RenderTypeahead } from "forms/fields";
import PropTypes from "prop-types";
import { currentUserShape } from "shapes";

import Translate from "utils/translate";
import { isRequired } from "utils/validation";

const { t } = new Translate("ProposalForm");

const Deal = ({ currentUser, formik: { setFieldValue } }) => {
  const onSelectDeal = (deal) => {
    setFieldValue("deal", deal);
    setFieldValue("portfolio", deal.portfolio);
    setFieldValue("asset", deal.asset);
  };

  return (
    <FormContainer title={t("deal")}>
      <FormRow>
        <Field
          component={RenderTypeahead}
          label={t("dealLabel")}
          name="deal.name"
          onChange={(name) => setFieldValue("deal", { name })}
          onSelect={onSelectDeal}
          searchIndex="Deal"
          searchKey="display_name"
          searchParameters={{
            facets: "collaborator_ids",
            filters: `collaborator_ids:${currentUser.id}`,
          }}
          validate={isRequired}
        />
      </FormRow>
    </FormContainer>
  );
};

Deal.propTypes = {
  currentUser: PropTypes.shape(currentUserShape),
  formik: PropTypes.shape({
    setFieldValue: PropTypes.func.isRequired,
  }),
};

export default Deal;
